import React, { useState, useCallback } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';

/*  DATA  */
const SECTIONS = [
  { label: 'Home', href: '#hero' },
  { label: 'About', href: '#about' },
  { label: 'Features', href: '#features' },
  { label: 'How It Works', href: '#how-it-works' },
  { label: 'Benefits', href: '#benefits' },
  { label: 'Use Cases', href: '#use-cases' },
  { label: 'Testimonials', href: '#testimonials' },
  { label: 'Integrations', href: '#integrations' },
  { label: 'Pricing', href: '#pricing' },
  { label: 'Blog', href: '#blog' },
  { label: 'FAQ', href: '#faq' },
  { label: 'Contact', href: '#contact' },
];

const LEGAL = [
  { label: 'Privacy Policy', to: '/privacy-policy' },
  { label: 'Terms of Service', to: '/terms-of-service' },
  { label: 'Security', to: '/security' },
  { label: 'GDPR', to: '/gdpr' },
  { label: 'Cookie Policy', to: '/cookie-policy' },
];

const SOCIALS = [
  { name: 'X', icon: <svg viewBox="0 0 24 24" fill="currentColor" className="w-[18px] h-[18px]"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>, url: 'https://x.com/opticvance' },
  { name: 'Pinterest', icon: <svg viewBox="0 0 24 24" fill="currentColor" className="w-[18px] h-[18px]"><path d="M12 2C6.48 2 2 6.48 2 12c0 4.41 2.87 8.15 6.86 9.43-.09-.8-.17-2.03.03-2.9.19-.82 1.23-5.22 1.23-5.22s-.31-.62-.31-1.53c0-1.43.83-2.49 1.87-2.49.88 0 1.31.66 1.31 1.45 0 .88-.56 2.2-.85 3.42-.24 1.02.51 1.85 1.52 1.85 1.82 0 3.22-1.92 3.22-4.69 0-2.45-1.77-4.17-4.29-4.17-2.92 0-4.65 2.19-4.65 4.46 0 .88.34 1.45.87 1.91.24.25.27.34.18.62-.06.2-.2.68-.25.87-.08.31-.32.42-.59.31-1.66-.61-2.7-2.49-2.7-4.02 0-3.27 2.38-6.28 6.88-6.28 3.61 0 6.42 2.57 6.42 6.01 0 3.6-2.27 6.5-5.41 6.5-1.05 0-2.04-.55-2.38-1.2 0 0-.57 2.19-.71 2.72-.26 1.03-.98 2.07-1.47 2.85C17.7 21.86 20 17.44 20 12c0-5.52-4.48-10-10-10z"/></svg>, url: 'https://www.pinterest.com/Opticvance/' },
  { name: 'YouTube', icon: <svg viewBox="0 0 24 24" fill="currentColor" className="w-[18px] h-[18px]"><path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>, url: 'https://www.youtube.com/@Opticvance' },
  { name: 'Facebook', icon: <svg viewBox="0 0 24 24" fill="currentColor" className="w-[18px] h-[18px]"><path d="M22.675 0H1.325C.593 0 0 .593 0 1.326v21.348C0 23.407.593 24 1.325 24H12.82v-9.294H9.692V11.01h3.128V8.413c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.464.099 2.794.143v3.24l-1.918.001c-1.504 0-1.796.715-1.796 1.764v2.314h3.587l-.467 3.696h-3.12V24h6.116C23.407 24 24 23.407 24 22.674V1.326C24 .593 23.407 0 22.675 0z"/></svg>, url: 'https://www.facebook.com/Opticvance/' },
  { name: 'LinkedIn', icon: <svg viewBox="0 0 24 24" fill="currentColor" className="w-[18px] h-[18px]"><path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.761 0 5-2.239 5-5v-14c0-2.761-2.239-5-5-5zm-11.5 20h-3v-10h3v10zm-1.5-11.268c-.966 0-1.75-.79-1.75-1.766s.784-1.766 1.75-1.766c.966 0 1.75.79 1.75 1.766s-.784 1.766-1.75 1.766zm13 11.268h-3v-5.604c0-1.336-.025-3.056-1.863-3.056-1.865 0-2.151 1.457-2.151 2.963v5.697h-3v-10h2.878v1.367h.041c.401-.76 1.379-1.563 2.838-1.563 3.035 0 3.597 1.998 3.597 4.596v5.6z"/></svg>, url: 'https://www.linkedin.com/company/opticvance/' },
];

/*  Helpers  */
const SectionLink = ({ href, label }) => {
  const location = useLocation();
  const handleClick = (e) => {
    if (location.pathname === '/') {
      e.preventDefault();
      const el = document.querySelector(href);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
  };
  return (
    <Link to={`/${href}`} onClick={handleClick}
      className="text-gray-500 hover:text-primary text-xs transition-colors duration-200">
      {label}
    </Link>
  );
};

const BackToTop = () => {
  const scrollToTop = useCallback(() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }, []);
  return (
    <motion.button onClick={scrollToTop}
      className="fixed bottom-8 right-8 z-50 w-11 h-11 rounded-full bg-primary/10 border border-primary/25 text-primary flex items-center justify-center backdrop-blur-sm hover:bg-primary/20 transition-all duration-300 focus:outline-none"
      whileHover={{ scale: 1.1, y: -2 }} whileTap={{ scale: 0.95 }}
      initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
      aria-label="Back to top">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4"><polyline points="18 15 12 9 6 15"/></svg>
    </motion.button>
  );
};

/*  NODE LINES (decorative lines between newsletter nodes)  */
const NodeLine = ({ x1, y1, x2, y2, delay }) => (
  <motion.line x1={x1} y1={y1} x2={x2} y2={y2}
    stroke="#08CB00" strokeWidth="1" strokeOpacity="0.15"
    initial={{ pathLength: 0 }} whileInView={{ pathLength: 1 }}
    viewport={{ once: true }} transition={{ duration: 1.2, delay, ease: 'easeOut' }} />
);

const NodeDot = ({ cx, cy, delay }) => (
  <motion.circle cx={cx} cy={cy} r="2" fill="#08CB00" fillOpacity="0.3"
    initial={{ scale: 0, opacity: 0 }}
    whileInView={{ scale: 1, opacity: 1 }}
    viewport={{ once: true }}
    transition={{ duration: 0.4, delay }} />
);

/*  NEWSLETTER  */
const Newsletter = () => {
  const [email, setEmail] = useState('');
  const [state, setState] = useState('idle'); // idle | sending | done | error

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setState('sending');

    try {
      const formData = new URLSearchParams();
      formData.append('email', email);
      formData.append('_subject', 'Newsletter signup - OpticVance');

      const res = await fetch('https://formspree.io/f/xpqjkykn', {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' },
      });

      if (res.ok) {
        setState('done');
        setEmail('');
      } else {
        setState('error');
      }
    } catch (err) {
      setState('error');
    }
  };

  return (
    <div className="relative max-w-3xl mx-auto">
      {/* Neural network SVG background decoration */}
      <svg className="absolute inset-0 w-full h-full pointer-events-none" viewBox="0 0 600 200" preserveAspectRatio="none" aria-hidden="true">
        <NodeLine x1="0" y1="100" x2="80" y2="40" delay={0} />
        <NodeLine x1="80" y1="40" x2="200" y2="70" delay={0.1} />
        <NodeLine x1="200" y1="70" x2="300" y2="30" delay={0.2} />
        <NodeLine x1="300" y1="30" x2="420" y2="80" delay={0.3} />
        <NodeLine x1="420" y1="80" x2="520" y2="45" delay={0.4} />
        <NodeLine x1="520" y1="45" x2="600" y2="100" delay={0.5} />
        <NodeLine x1="0" y1="180" x2="120" y2="140" delay={0.2} />
        <NodeLine x1="120" y1="140" x2="250" y2="160" delay={0.3} />
        <NodeLine x1="250" y1="160" x2="380" y2="130" delay={0.4} />
        <NodeLine x1="380" y1="130" x2="500" y2="170" delay={0.5} />
        <NodeLine x1="500" y1="170" x2="600" y2="140" delay={0.6} />
        <NodeLine x1="80" y1="40" x2="120" y2="140" delay={0.4} />
        <NodeLine x1="300" y1="30" x2="250" y2="160" delay={0.5} />
        <NodeLine x1="520" y1="45" x2="500" y2="170" delay={0.6} />
        <NodeDot cx="80" cy="40" delay={0.3} />
        <NodeDot cx="200" cy="70" delay={0.4} />
        <NodeDot cx="300" cy="30" delay={0.5} />
        <NodeDot cx="420" cy="80" delay={0.6} />
        <NodeDot cx="520" cy="45" delay={0.7} />
        <NodeDot cx="120" cy="140" delay={0.5} />
        <NodeDot cx="250" cy="160" delay={0.6} />
        <NodeDot cx="380" cy="130" delay={0.7} />
        <NodeDot cx="500" cy="170" delay={0.8} />
      </svg>

      <motion.div
        className="relative rounded-2xl border border-primary/15 bg-gradient-to-br from-primary/[0.04] via-transparent to-primary/[0.02] p-8 sm:p-10 overflow-hidden"
        initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }} transition={{ duration: 0.6 }}
      >
        {/* Pulse ring decoration */}
        <div className="absolute -top-20 -right-20 w-40 h-40 rounded-full border border-primary/10 animate-ping opacity-20 pointer-events-none" />
        <div className="absolute -bottom-16 -left-16 w-32 h-32 rounded-full border border-primary/10 animate-ping opacity-10 pointer-events-none" style={{ animationDelay: '1s' }} />

        <div className="relative z-10 text-center">
          {/* AI chip icon */}
          <motion.div
            className="w-12 h-12 mx-auto mb-4 rounded-xl bg-primary/10 border border-primary/20 flex items-center justify-center"
            whileHover={{ rotate: 90, scale: 1.1 }}
            transition={{ type: 'spring', stiffness: 300 }}
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="#08CB00" strokeWidth="1.5" className="w-6 h-6">
              <rect x="5" y="5" width="14" height="14" rx="2" />
              <circle cx="12" cy="12" r="3" />
              <path d="M12 1v4M12 19v4M1 12h4M19 12h4M4.2 4.2l2.8 2.8M17 17l2.8 2.8M4.2 19.8l2.8-2.8M17 7l2.8-2.8" strokeOpacity="0.5" />
            </svg>
          </motion.div>

          <h3 className="text-lg sm:text-xl font-bold text-white mb-1.5">
            Stay ahead with <span className="text-primary">AI insights</span>
          </h3>
          <p className="text-gray-500 text-sm mb-6 max-w-md mx-auto">
            Weekly curated analytics research, product updates, and exclusive early access  no spam, unsubscribe anytime.
          </p>

          <AnimatePresence mode="wait">
            {state === 'done' ? (
              <motion.div
                key="done"
                className="flex items-center justify-center gap-2 py-3 text-primary"
                initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }}
                transition={{ type: 'spring', stiffness: 400 }}
              >
                <motion.svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" className="w-5 h-5"
                  initial={{ pathLength: 0 }} animate={{ pathLength: 1 }} transition={{ duration: 0.5 }}>
                  <path d="M20 6L9 17l-5-5" />
                </motion.svg>
                <span className="font-medium text-sm">You're in! Check your inbox.</span>
              </motion.div>
            ) : (
              <motion.form key="form" onSubmit={handleSubmit}
                className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
                initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
                <div className="relative flex-1 group">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"
                    className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-600 group-focus-within:text-primary transition-colors">
                    <rect x="2" y="4" width="20" height="16" rx="3" />
                    <path d="M2 7l10 7 10-7" />
                  </svg>
                  <input type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                    placeholder="your@email.com" required
                    className="w-full bg-black/40 border border-dark-border rounded-xl pl-10 pr-4 py-3 text-sm text-white placeholder-gray-600 outline-none focus:border-primary/40 transition-colors"
                  />
                </div>
                <motion.button type="submit" disabled={state === 'sending'}
                  className="relative px-6 py-3 rounded-xl bg-primary text-black text-sm font-semibold overflow-hidden disabled:opacity-70 flex items-center justify-center gap-2 flex-shrink-0"
                  whileHover={{ scale: 1.03, boxShadow: '0 0 20px rgba(8,203,0,0.3)' }}
                  whileTap={{ scale: 0.97 }}>
                  {/* Shimmer */}
                  <motion.span className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -skew-x-12"
                    animate={{ x: ['-150%', '150%'] }}
                    transition={{ duration: 2.5, repeat: Infinity, ease: 'linear' }} />
                  <span className="relative z-10">
                    {state === 'sending' ? (
                      <motion.svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" className="w-4 h-4 animate-spin">
                        <path d="M12 2a10 10 0 0 1 10 10" />
                      </motion.svg>
                    ) : 'Subscribe'}
                  </span>
                </motion.button>
              </motion.form>
            )}
          </AnimatePresence>

          <p className="text-[11px] text-gray-600 mt-4">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-3 h-3 inline -mt-0.5 mr-1">
              <rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/>
            </svg>
            We respect your privacy. Read our <Link to="/privacy-policy" className="text-primary/60 hover:text-primary transition-colors">Privacy Policy</Link>.
          </p>
        </div>
      </motion.div>
    </div>
  );
};

/*  FOOTER  */
const Footer = () => (
  <footer className="relative z-10 bg-[#000000] border-t border-dark-border/20" role="contentinfo">
    {/* Newsletter */}
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <Newsletter />
    </div>

    {/* Divider */}
    <div className="max-w-5xl mx-auto h-px bg-gradient-to-r from-transparent via-primary/15 to-transparent" />

    {/* Links grid: Sections + Legal + Socials */}
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
        {/* Sections */}
        <div>
          <h4 className="text-[11px] uppercase tracking-[0.15em] text-gray-600 font-semibold mb-4">Sections</h4>
          <div className="flex flex-wrap gap-x-4 gap-y-2">
            {SECTIONS.map((s) => (
              <SectionLink key={s.href} href={s.href} label={s.label} />
            ))}
          </div>
        </div>

        {/* Legal */}
        <div>
          <h4 className="text-[11px] uppercase tracking-[0.15em] text-gray-600 font-semibold mb-4">Legal</h4>
          <div className="flex flex-col gap-2">
            {LEGAL.map((item) => (
              <Link key={item.to} to={item.to}
                className="text-gray-500 hover:text-primary text-xs transition-colors duration-200 inline-flex items-center gap-1.5 group">
                <span className="w-1 h-1 rounded-full bg-primary/30 group-hover:bg-primary transition-colors" />
                {item.label}
              </Link>
            ))}
          </div>
        </div>

        {/* Connect */}
        <div>
          <h4 className="text-[11px] uppercase tracking-[0.15em] text-gray-600 font-semibold mb-4">Connect</h4>
          <div className="flex gap-2">
            {SOCIALS.map((s) => (
              <motion.a key={s.name} href={s.url} target="_blank" rel="noopener noreferrer"
                className="w-9 h-9 rounded-lg bg-white/[0.03] border border-dark-border/40 flex items-center justify-center text-gray-500 hover:text-primary hover:border-primary/30 hover:bg-primary/5 transition-all duration-200"
                whileHover={{ scale: 1.1, rotate: [0, -8, 8, 0] }}
                whileTap={{ scale: 0.9 }}
                aria-label={s.name}>
                {s.icon}
              </motion.a>
            ))}
          </div>
          <p className="text-gray-600 text-[11px] mt-3 leading-relaxed">
            Follow us for the latest updates, product news, and AI research insights.
          </p>
        </div>
      </div>
    </div>

    {/* Bottom bar */}
    <div className="border-t border-dark-border/20">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-[11px] text-gray-600">
        <p>&copy; {new Date().getFullYear()} OpticVance. All rights reserved.</p>
        <span className="inline-flex items-center gap-1.5 font-mono tracking-wider select-none">
          <span className="w-1.5 h-1.5 rounded-full bg-primary/50 animate-pulse" />
          Powered by xAI
        </span>
      </div>
    </div>

    <BackToTop />
  </footer>
);

export default Footer;
